import * as types from 'modulesV2/constants/';

const initialState = {
  text: '',
  open: false
};

export default function message(state = initialState, action) {
  switch (action.type) {
    case types.CREATE_MESSAGE: {
      return {
        open: true,
        ...action.data
      };
    }

    case types.DELETE_MESSAGE: {
      return {
        ...state,
        open: false
      };
    }

    default:
      return state;
  }
}
